import { combineReducers } from "redux";
import getChatClickReducer from "./adminChatClickReducer";
import bankDetailsReducer from "./bankDetailsReducer";
import getUnreadReducer from "./getUnreadMessage";
import investmentPlanReducer from "./investmentPlanReducer";
import toggleReducer from "./toggleMessageReducer";
import userRandomNumberReducer from "./userRandomNumberReducer";
import userReducer from "./userReducer";
const rootReducer = combineReducers({
  userReducer: userReducer,
  bankDetailReducer: bankDetailsReducer,
  investmentReducer: investmentPlanReducer,
  userRandomNumber: userRandomNumberReducer,
  toggleReducer: toggleReducer,
  getUnreadReducer: getUnreadReducer,
  getChatClickReducer: getChatClickReducer,
});
export default rootReducer;
